import { TableCell } from '@mui/material'

const TaxCellCollapsible = () => <TableCell colSpan={2} />

export default TaxCellCollapsible
